import { createParser, fields } from '../utils/parse';

export const Notification = createParser('Notification', {
  link: fields.string(''),
  notifierName: fields.string('', { path: 'notifier_name' }),
  action: fields.string(''),
  parentObjectName: fields.string('', { path: 'parent_object_name' }),
  directNotifiedAt: fields.string('', { path: 'direct_notified_at' }),
  readAt: fields.string('', { path: 'read_at' }),
});

export const NotificationsApi = createParser('NotificationsApi', {
  errors: fields.array(fields.string(''), { path: 'errors' }),
  newNotifications: fields.number(0, { path: 'new_notifications_count' }),
  notifications: fields.array(Notification, { path: 'notifications' }),
});

export default NotificationsApi;
